import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import DeliveryDetails from '../../components/DeliveryDetails'

function DeliveryDetailPage() {
    return (
        <>
            <Helmet>
                <title>Delivery Order Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <DeliveryDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default DeliveryDetailPage;

